import { Question } from "../util/utilClass";

function isStringAnArray(str) {
  const trimmedStr = str.trim();
  if (!(trimmedStr.startsWith("[") && trimmedStr.endsWith("]"))) {
    return false;
  }

  try {
    const parsed = JSON.parse(trimmedStr);
    if (!Array.isArray(parsed)) {
      return false;
    }
    if (
      trimmedStr.slice(1, -1).includes("[") ||
      trimmedStr.slice(1, -1).includes("]")
    ) {
      return false;
    }
    return true;
  } catch (e) {
    // If JSON.parse() fails, the string is not a valid JSON array
    return false;
  }
}

const question = (recordLogic) =>
  new Question(
    "coding",
    recordLogic === "record"
      ? ["coding1-easy-remove-duplicates-from-sorted-list.md"]
      : [
          "coding2-easy_remove_duplicates-with.md",
          "coding2-easy_remove_duplicates-without.md",
        ],
    [],
    null,
    null,
    [
      { input: "[1,1,2]", output: "[1,2]" },
      { input: "[1,1,2,3,3]", output: "[1,2,3]" },
    ],
    `The input consists of the values of all nodes presented as an array. For example, [1,1,2] represents node(1) => node(1) => node(2).\n 
    Please note that both the input and the output refer to the head of a linked list, NOT an array. We use an array to represent the input and output merely for simplicity.`,
    `
function ListNode(val, next) {
this.val = val === undefined ? 0 : val;
this.next = next === undefined ? null : next;
}

function arrayToLinkedList(arr) {
if (arr.length === 0) return undefined; // Handle empty array case

let head = new ListNode(arr[0]); // Create the head of the linked list
let current = head;

for (let i = 1; i < arr.length; i++) {
current.next = new ListNode(arr[i]); // Create and link the next node
current = current.next; // Move to the newly created node
}

return head; // Return the head of the linked list
}

function linkedListToArray(head) {
let arr = []; // Initialize an empty array to hold the node values

let current = head; // Start with the head of the linked list

while (current !== null && current !== undefined) {
// Push the current node's value to the array, allowing for 'undefined' values
arr.push(current.val);

// Move to the next node in the list
current = current.next;
}

return arr; // Return the array containing all node values
}
`,
    `
var res = function (str) {
let arrayOld = JSON.parse(str);
let linkedListOld = arrayToLinkedList(arrayOld);
let linkedListNew = deleteDuplicates(linkedListOld);
let arrayNew = linkedListToArray(linkedListNew);
return JSON.stringify(arrayNew);
};

const fs = require("fs");
let input = fs.readFileSync("/dev/stdin").toString();
console.log(res(input));
`,
    recordLogic,
    recordLogic === "record"
      ? `/**
* Definition for singly-linked list.
* function ListNode(val, next) {
*   this.val = (val===undefined ? 0 : val)
*   this.next = (next===undefined ? null : next)
* }
*/
/**
* @param {ListNode} head
* @return {ListNode}
*/
var deleteDuplicates = function(head) {
  
};`
      : null,
    [
      { stdin: "[1,2,3]", expected_output: "[1,2,3]" },
      { stdin: "[1,1,2]", expected_output: "[1,2]" },
      { stdin: "[1,1,2,3,3,4,5,5]", expected_output: "[1,2,3,4,5]" },
      { stdin: "[7,7,7,7]", expected_output: "[7]" },
      { stdin: "[]", expected_output: "[]" },
      { stdin: "[-3,-3,0,1,1,2,3,3]", expected_output: "[-3,0,1,2,3]" },
      { stdin: "[2,2,3,3,4,4,4]", expected_output: "[2,3,4]" },
      {
        stdin: "[1,1,2,3,3,4,5,5,6]",
        expected_output: "[1,2,3,4,5,6]",
      },
      {
        stdin:
          "[1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,14,14,15,15,16,16,17,17,18,18,19,19,20,20]",
        expected_output: "[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]",
      },
      {
        stdin:
          "[100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100]",
        expected_output: "[100]",
      },
    ],
    isStringAnArray,
    isStringAnArray
  );

export default question;
